import React, { useEffect, useState, useRef } from "react";
import { useFirebase } from "react-redux-firebase";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import LogoType from "../../utils/LogoType";

const Recents = () => {
  const [recents, setRecents] = useState([]);
  const firebase = useFirebase();
  const descriptionsRef = useRef();
  const langCode = useSelector((store) => store.options.lang.code);

  useEffect(() => {
    if (recents && Object.keys(recents).length === 0) {
      firebase
        .ref("blog_entries")
        .orderByChild("meta/creationDate")
        .limitToFirst(3)
        .on("value", (snapshot) => {
          setRecents(snapshot.val());
        });
    }
  }, [setRecents, firebase, recents]);

  const getText = (htmlString) => {
    descriptionsRef.current.innerHTML = htmlString;
    const text = descriptionsRef.current.innerText;
    descriptionsRef.current.innerHTML = "";
    return text;
  };

  return (
    <>
      <span style={{ display: "none" }} ref={descriptionsRef}></span>
      <ul className="recent-entries">
        {recents &&  Object.keys(recents)
          .reverse()
          .map((key) => {
            const element = recents[key];

            let displayedLang = "esp";
            if (element.content[langCode]) {
              displayedLang = langCode;
            } else {
              if (langCode === "esp") {
                displayedLang = "en";
              } else if (langCode === "en") {
                displayedLang = "esp";
              }
            }
            return (
              <li key={key} className="recent-entry">
                <Link to={`/entry/${element.slug}`}>
                  <img
                    src={
                      element.content[displayedLang].featured_image
                        ? `https://res.cloudinary.com/rauru/image/upload/c_thumb,h_240,w_150/v1601074827/${element.content[displayedLang].featured_image}`
                        : "https://res.cloudinary.com/rauru/image/upload/c_thumb,h_240,w_150/v1602039132/placeholder.png"
                    }
                    alt={`featured-${key}`}
                  ></img>
                </Link>

                <div className="content">
                  <div className="head">
                    <Link to={`/entry/${element.slug}`}>
                      <h4>{element.content[displayedLang].title}</h4>
                    </Link>
                    <LogoType type={element.entryType} className="type-logo" />
                  </div>
                  <p>
                    {getText(element.content[displayedLang].description).slice(
                      0,
                      20
                    )}
                    {getText(element.content[displayedLang].description)
                      .length > 20 && "..."}
                  </p>
                  <ul>
                    {element.meta.tags &&
                      Object.keys(element.meta.tags).length > 0 &&
                      Object.keys(element.meta.tags).map((tag) => {
                        return (
                          <li className="tag" key={`${key}-tag-${tag}`}>
                            <Link to={`/blog/1?tag=${tag}`}>
                              {tag.replace("_", " ")}
                            </Link>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </li>
            );
          })}
      </ul>
    </>
  );
};

export default Recents;
